import { MultiSelect, MultiSelectProps } from '@mantine/core';

import { useGetMarketCategoriesQuery } from '@api/marketCategory.api';
import { uniqueByName } from '@utils/strings';

export default function MarketCategoriesSelector(props: MultiSelectProps) {
  const { data = [], isLoading } = useGetMarketCategoriesQuery();

  return (
    <MultiSelect
      label="Mercati di interesse"
      data={uniqueByName(data).map((category) => ({
        label: category.name,
        value: category.name,
      }))}
      {...props}
      disabled={isLoading || props.disabled}
      placeholder={
        props.value && props.value.length !== 0
          ? undefined
          : props.placeholder || 'Seleziona i mercati di interesse'
      }
    />
  );
}
